<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <mat-label>{{data.detail}}</mat-label>
  <mat-action-list>
    <button *ngFor="let item of data.itens" mat-list-item [mat-dialog-close]="item">{{item}}</button>
  </mat-action-list>
</div>
<div mat-dialog-actions>
  <div class="filler"></div>
  <button mat-button [mat-dialog-close]="">{{data.cancel}}</button>
</div>